export const years = [
  { value: 'less than 1', label: 'less than 1' },
  { value: 'less than 3', label: 'less than 3' },
  { value: 'less than 5', label: 'less than 5' },
  { value: 'less than 8', label: 'less than 8' },
  { value: 'more than 8', label: 'more than 8' },
];

export const availabilityOptions = [
  { value: '4 hours', label: '4 hours / month' },
  { value: '8 hours', label: '8 hours / month' },
  { value: '16 hours', label: '16 hours / month' },
  { value: '20 hours', label: '20 hours / month' },
];

export const allInterests = [
  { value: 'a', label: 'a' },
  { value: 'b', label: 'b' },
  { value: 'c', label: 'c' },
  { value: 'd', label: 'd' },
  { value: 'e', label: 'e' },
];